import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CertemyCommonModule } from 'common/certemy-common.module';
import {
  CardModule,
  BreadcrumbsModule,
  PageHeaderModule,
  PaginationModule,
  SmartTableModule,
  PageActionsModule,
  CardFooterPaginationModule,
  SearchInputModule,
} from '@certemy/ui-components';
import { AssignmentsService } from 'services/assignments/assignments.service';
import { NgbCustomModalModule } from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.module';
import { assignmentsListResolver } from './assignments-list.resolver';
import { AssignmentsListComponent } from './assignments-list.component';

@NgModule({
  declarations: [AssignmentsListComponent],
  imports: [
    CertemyCommonModule,
    CardModule,
    BreadcrumbsModule,
    PageHeaderModule,
    PaginationModule,
    SmartTableModule,
    PageActionsModule,
    CardFooterPaginationModule,
    SearchInputModule,
    NgbCustomModalModule,
    RouterModule.forChild([
      {
        path: '',
        component: AssignmentsListComponent,
        resolve: { assignmentsData: assignmentsListResolver },
      },
    ]),
  ],
  providers: [AssignmentsService],
})
export class AssignmentsListModule {}
